import { Tooltip } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { $danger } from 'constants/styles';

const ErrorTooltip = withStyles(() => ({
	tooltip: {
		backgroundColor: $danger,
		fontSize: 11.5,
		padding: '5px 10px',
		opacity: 1
	}
}))(Tooltip);

export default ErrorTooltip;
